import { render, staticRenderFns } from "./StatusProcesso.vue?vue&type=template&id=a8986228"
import script from "./StatusProcesso.vue?vue&type=script&lang=js"
export * from "./StatusProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports